export default "__VITE_ASSET__255e48b8__"